import {Component, Input, OnInit} from '@angular/core';

import {BreadcrumbModel} from '../../models/Breadcrumb.class';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadscrumb.component.html',
    styleUrls: ['./breadscrumb.component.css']
})
export class BreadscrumbComponent implements OnInit {

    @Input('breadcrumbs') breadcrumbs: BreadcrumbModel[];

    constructor() {

    }

    ngOnInit() {


    }

}
